// return all revenue centers and menu uuids
export const getAllRevenueCentersAndMenusUuids = (
  revenueCentersAndMenus
) =>
  revenueCentersAndMenus?.reduce((acc, cur) => {
    const menusUuids = cur?.menus?.map(({ uuid }) => uuid)

    return [...acc, cur?.uuid, ...menusUuids]
  }, []) ?? []
